module.exports = __webpack_public_path__ + "aw.svg?3f52fb17e14398c3a3d8e5cece4f9009";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/aw.svg
// module id = 1236
// module chunks = 0